import { render, staticRenderFns } from "./PastPurchases.vue?vue&type=template&id=30c81763&scoped=true&"
import script from "./PastPurchases.vue?vue&type=script&lang=js&"
export * from "./PastPurchases.vue?vue&type=script&lang=js&"
import style0 from "./PastPurchases.vue?vue&type=style&index=0&id=30c81763&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c81763",
  null
  
)

component.options.__file = "PastPurchases.vue"
export default component.exports